<template>
  <v-card>
    <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
      <v-toolbar-title class="headline grey-text">Edit Transfer</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="UpdateEditedTransfer($v.editTransfer)">
        <v-icon color="green">fas fa-check</v-icon>
      </v-btn>
      <v-btn icon @click.native="$router.push({ path: '/dashboard/transfer' })">
        <v-icon color="red">fas fa-times</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text style="padding-top: 0;">
      <v-container grid-list-md v-bind:class="{'padContent': !drawer}">
        <v-layout wrap>
          <v-flex xs12>
            <v-select v-bind:items="currency"
                      label="Currency"
                      v-model="editTransfer.currency"
                      :error-messages="currencyErrors"
                      @input="$v.editTransfer.currency.$touch()"
                      @blur="$v.editTransfer.currency.$touch()"
                      @change="selectedCurrencyChanged"></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="editTransfer.transferName"
                          label="Transfer Name"
                          :error-messages="transferNameErrors"
                          @input="$v.editTransfer.transferName.$touch()"
                          @blur="$v.editTransfer.transferName.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete :items="account"
                            v-model="editTransfer.transferFrom"
                            label="Transfer From Account"
                            item-text="accountName"
                            item-value="accountName"
                            chips
                            prepend-icon="fa-balance-scale"
                            hint="Transfer from Account?"
                            persistent-hint
                            :error-messages="transferFromErrors"
                            @input="$v.editTransfer.transferFrom.$touch()"
                            @blur="$v.editTransfer.transferFrom.$touch()"
                            max-height="auto">
              <template slot="selection" slot-scope="data">
                <v-chip @input="data.parent.selectItem(data.item)"
                        :selected="data.selected"
                        class="chip--select-multi"
                        :key="JSON.stringify(data.item)">

                  {{ data.item.accountName }}
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>

                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete :items="account"
                            v-model="editTransfer.transferTo"
                            label="Transfer To Account"
                            item-text="accountName"
                            item-value="accountName"
                            chips
                            prepend-icon="fa-balance-scale"
                            hint="Transfer To Account?"
                            persistent-hint
                            :error-messages="transferToErrors"
                            @input="$v.editTransfer.transferTo.$touch()"
                            @blur="$v.editTransfer.transferTo.$touch()"
                            max-height="auto">
              <template slot="selection" slot-scope="data">
                <v-chip @input="data.parent.selectItem(data.item)"
                        :selected="data.selected"
                        class="chip--select-multi"
                        :key="JSON.stringify(data.item)">

                  {{ data.item.accountName }}
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete :items="category"
                            v-model="editTransfer.category"
                            label="Category"
                            chips
                            prepend-icon="fa-tags"
                            hint="What Category does this belong to?"
                            persistent-hint
                            :error-messages="categoryErrors"
                            @input="$v.editTransfer.category.$touch()"
                            @blur="$v.editTransfer.category.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Transfer Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                          v-model="editTransfer.transferAmount"
                          :error-messages="transferAmountErrors"
                          @input="$v.editTransfer.transferAmount.$touch()"
                          @blur="$v.editTransfer.transferAmount.$touch()"></v-text-field>

          </v-flex>
          <v-flex xs12>
            <v-text-field label="Comment" prepend-icon="fa-comment" v-model="editTransfer.comment"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-menu ref="datemenu"
                    lazy
                    :close-on-content-click="false"
                    v-model="datemenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="editTransfer.transferDate">
              <v-text-field slot="activator"
                            label="Date Picker"
                            v-model="editTransfer.transferDate"
                            prepend-icon="fa-calendar"
                            readonly></v-text-field>
              <v-date-picker v-model="editTransfer.transferDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="datemenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.datemenu.save(editTransfer.transferDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="timemenu"
                      persistent
                      v-model="timemenuvisibilty"
                      lazy
                      full-width
                      width="290px"
                      :return-value.sync="editTransfer.transferTime">
              <v-text-field slot="activator"
                            label="Time Picker"
                            v-model="editTransfer.transferTime"
                            prepend-icon="access_time"
                            readonly></v-text-field>
              <v-time-picker v-model="editTransfer.transferTime" actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.timemenu.save(editTransfer.transferTime)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-select v-bind:items="paymentType" v-model="editTransfer.paymentType"
                      label="Payment Type"
                      chips
                      :error-messages="paymentTypeErrors"
                      @input="$v.editTransfer.paymentType.$touch()"
                      @blur="$v.editTransfer.paymentType.$touch()"></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'

  import { globalFunctions } from '../../javascript/globalFunctions'
  import { transferManager } from '../../javascript/transferManager'

  export default {
    mixins: [validationMixin],
    props: ['drawer'],
    data() {
      return {
        paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
        category: ["cat1", "cat2", "cat3", "cat4"],
        currency: ["JMD", "USD"],
        account: [],
        datemenu: false,
        timemenuvisibilty: false,
        editTransfer: {
          id: 0,
          currency: '',
          transferName: '',
          category: '',
          transferAmount: 0,
          comment: '',
          paymentType: '',

          transferFrom: '',
          transferTo: '',

          transferDate: '',
          transferTime: null,

          //State of Current Object
          objectState: 'New'
        },
        transferItems: []
      }
    },
    computed: {
      transferFromErrors() {
        const errors = []
        if (!this.$v.editTransfer.transferFrom.$dirty) return errors
        !this.$v.editTransfer.transferFrom.required && errors.push('Tranfer from is required')
        return errors
      },
      transferToErrors() {
        const errors = []
        if (!this.$v.editTransfer.transferTo.$dirty) return errors
        !this.$v.editTransfer.transferTo.required && errors.push('Tranfer to is required')
        if (this.editTransfer.transferTo === this.editTransfer.transferFrom) errors.push('Cannot tranfer to the same Account')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.editTransfer.category.$dirty) return errors
        !this.$v.editTransfer.category.required && errors.push('Category is required')
        return errors
      },
      transferAmountErrors() {
        const errors = []
        if (!this.$v.editTransfer.transferAmount.$dirty) return errors
        !this.$v.editTransfer.transferAmount.minValue && errors.push('Transfer Amount must be at least 1')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.editTransfer.currency.$dirty) return errors
        !this.$v.editTransfer.currency.required && errors.push('Currency is required')
        return errors
      },
      transferNameErrors() {
        const errors = []
        if (!this.$v.editTransfer.transferName.$dirty) return errors
        !this.$v.editTransfer.transferName.required && errors.push('Transfer Name is required')
        return errors
      },
      paymentTypeErrors() {
        const errors = []
        if (!this.$v.editTransfer.paymentType.$dirty) return errors
        !this.$v.editTransfer.paymentType.required && errors.push('Payment Type is required')
        return errors
      }
    },
    methods: {
      transferCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.editTransfer.transferAmount < 0 || !globalFunctions.isIntOrFloat(this.editTransfer.transferAmount) || this.editTransfer.transferAmount === "") { this.editTransfer.transferAmount = 0 }

        if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transferAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false
        }

        return true
      },
      UpdateEditedTransfer: function ($v) {
        if (this.transferCheck($v)) {
          this.editTransfer.objectState = "Update"

          this.$store.commit('updateTransferinStore', this.editTransfer)

          transferManager.updateTransactionFromTransfer(this.EditTransfer)

          this.$router.push({ path: '/dashboard/transfer' })
        }
      },
      EditTransfer: function (item) {
        for (let i = 0; i < this.transferItems.length; i++) {
          if (this.transferItems[i].id === parseInt(item)) {
            let editEntry = JSON.parse(JSON.stringify(this.transferItems[i]))
            this.editTransfer = editEntry
            break
          }
        }
      },
      selectedCurrencyChanged: function () {
        ///////////////////////////////////////////////////////
        //Go Through Each Transaction Item
        ///////////////////////////////////////////////////////

        //for (let i = 0; i < this.transferItems.length; i++) {
        //  ////////////////////////////////////////////////////////////////
        //  //Loop conversions and test if currency already found
        //  ///////////////////////////////////////////////////////////////

        //  for (let x = 0; x < this.conversions.length; x++) {
        //    if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
        //      break
        //    } else if (x === this.conversions.length - 1) {
        //      this.getConversion(this.transactionItems[i].itemCurrency)
        //    }
        //  }
        //}
      }
    },
    beforeMount() {
      this.transferItems = this.$store.state.Transfers

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let cur = this.$store.state.Currencies
      for (let i = 0; i < cur.length; i++) {
        this.currency.push(cur[i].currencyName)
      }

      this.account = this.$store.state.Accounts
      
      this.EditTransfer(this.$route.params.itemId)
    },
    validations: {
      editTransfer: {
        transferName: {
          required
        },
        category: {
          required
        },
        transferAmount: {
          required,
          minValue: minValue(1)
        },
        transferDate: {
          required
        },
        transferTime: {
          required
        },
        paymentType: {
          required
        },
        currency: {
          required
        },
        transferFrom: {
          required
        },
        transferTo: {
          required
        }
      }
    }
    
  }

</script>



// WEBPACK FOOTER //
// src/components/transfer/EditTransfers.vue